import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryGoodsAttributes(
  goodsId,
  {
    page,
    size,
    direction,
    sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-attributes`,
    method: 'get',
    params: {
      goodsId,
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryGoodsAttribute(goodsId, goodsAttributeId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-attributes/${goodsAttributeId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  goodsId
 * @param  name
 * @param code
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addGoodsAttribute(
  goodsId,
  {
    name,
    code,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-attributes/${goodsId}`,
    method: 'post',
    data: {
      name,
      code,
    },
  });
}

/**
 * 更新
 * @param goodsId
 * @param  goodsAttributeId
 * @param  name
 * @param code
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateGoodsAttribute(goodsId, goodsAttributeId, {
  name,
  code,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-attributes/${goodsAttributeId}`,
    method: 'patch',
    data: {
      name,
      code,
    },
  });
}

/**
 * 删除
 * @param goodsId
 * @param goodsAttributeId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteGoodsAttribute(goodsId, goodsAttributeId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-attributes/${goodsAttributeId}`,
    method: 'delete',
  });
}
